import React, { useState } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import { Offcanvas, Pagination, Table } from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import TableBtns from "../Components/TableBtns";
import CountriesAndCities from "../hooks/projectshooks/CountriesAndCities";
import editBtn from "../assets/icons/PermissionEdit.png";
import deleteBtn from "../assets/icons/PermissionDelete.png";
import MainInput from "../Components/MainInput";
import Shimmer from "../Components/Shimmer";
import NoData from "../Components/NoData";
import addBtn from "../assets/icons/addBtn.png";

const Projects = () => {
  const {
    laoding,
    NavItems,
    deleteCountryLoading,
    deleteCountry,
    setSearch,
    handleShow,
    show,
    deleteCity,
    handleClose,
    cities,
    addNewCity,
    setCountryEn,
    setCountryAr,
    handleInputChange,
    handleAddNewCountry,
    loadingAddCountry,
    allCountries,
    handlePageChange,
    currentPage,
    totalPages,
    getPageNumbers,
    deletecityFromCountry,
    handleclickEditCity,
    setCountryID,
    deletecityFromCountryLoading,
    showEditCity,
    handleCloseEditCity,
    submitEditCity,
    setCityNameEnEdit,
    countryEditLoading,
    setCityNameArEdit,
    cityNameArEdit,
    editcityLoading,
    cityNameEnEdit,
    handleclickEditcountry,
    showEditCountry,
    handleCloseEditCountry,
    setcountryNameEnEdit,
    countryNameEnEdit,
    setcountryNameArEdit,
    countryNameArEdit,
    onSubmitEditCountry,
    handleClickAddGovernorate,
    handleAddNewGovernorate,
    loadingAddGovernorate,
    showAddGovernorate,
    setGovernorateEn,
    setGovernorateAr,
    handleCloseAddGovernorate
  } = CountriesAndCities();

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center justify-content-end">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <AddInput onClick={handleShow} />
        </div>

        {laoding ? (
          Array.from({ length: 3 }, (_, index) => (
            <div key={index} className="row py-4">
              <Shimmer
                style={{ height: "200px", borderRadius: "20px", width: "100%" }}
              />
            </div>
          ))
        ) : allCountries.length === 0 ? (
          <NoData />
        ) : (
          allCountries.map((country, index) => (
            <div
              className="border-bottom pb-3 overflow-y-scroll"
              key={index}
              style={{ height: "200px" }}
            >
              <Table hover className="text-center">
                <thead>
                  <tr>
                    <th className="bg-light">Country (English)</th>
                    <th className="bg-light">Country (Arabic)</th>
                    <th className="bg-light">City (English)</th>
                    <th className="bg-light">City (Arabic)</th>
                    <th className="bg-light">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={country?.governorates?.length}>
                      {country?.nameEn}
                    </td>
                    <td rowSpan={country?.governorates?.length}>
                      {country?.nameAr}
                    </td>
                    <td colSpan={3}>
                      {country?.governorates.map((city, cityIndx) => (
                        <div
                          key={cityIndx}
                          className="d-flex justify-content-between text-center ms-auto"
                          style={{ width: "85%" }}
                        >
                          <span>{city.nameEn}</span>
                          <span>{city.nameAr}</span>
                          <span className="text-start">
                            <TableBtns
                              onClickDelete={() => {
                                deletecityFromCountry(city?._id);
                              }}
                              onClickEdit={() => {
                                {
                                  handleclickEditCity(city);
                                  setCountryID(country._id);
                                }
                              }}
                              deleteloading={
                                deletecityFromCountryLoading[city?._id]
                              }
                            />
                          </span>
                        </div>
                      ))}
                    </td>
                  </tr>
                </tbody>
              </Table>
              <div className="text-end">
              <img
                  src={addBtn}
                  onClick={() => {
                    {
                      handleClickAddGovernorate();
                      setCountryID(country._id);
                    }
                  }}
                  className="cursor-pointer"
                  alt="addIcon"
                />
                <img
                  src={editBtn}
                  onClick={() => {
                    handleclickEditcountry(country);
                  }}
                  className="cursor-pointer"
                  alt="editBtn"
                />
                {deleteCountryLoading[country._id] ? (
                  <span className="text-center">
                    {" "}
                    <i className="fa-solid fa-fan fa-spin fa-spin-reverse mx-5"></i>
                  </span>
                ) : (
                  <img
                    onClick={() => {
                      deleteCountry(country._id);
                    }}
                    src={deleteBtn}
                    className="cursor-pointer"
                    alt="deleteBtn"
                  />
                )}
              </div>
            </div>
          ))
        )}
        {allCountries.length > 0 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {getPageNumbers().map((pageNumber) => (
                <Pagination.Item
                  linkClassName="bg-white text-black"
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        )}
      </MainContainer>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>Create New Country</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <form onSubmit={handleAddNewCountry}>
            <div className="d-flex flex-column gap-3">
              <div>
                <MainInput
                  label={"Name*"}
                  onChange={(e) => {
                    setCountryEn(e.target.value);
                  }}
                  placeholder={"Enter Name....."}
                  required={true}
                  type={"text"}
                />
                <MainInput
                  label={"*اسم"}
                  onChange={(e) => {
                    setCountryAr(e.target.value);
                  }}
                  placeholder={"....ادخل الاسم"}
                  required={true}
                  type={"text"}
                  dir="rtl"
                />
              </div>
              <div>
                <div className="d-flex justify-content-between px-4">
                  <h4>Add Cities</h4>
                  <h4>
                    <i
                      className="fa-solid fa-plus cursor-pointer"
                      onClick={addNewCity}
                    ></i>
                  </h4>
                </div>
                {cities.map((city, index) => (
                  <div key={index} className="pb-4 text-center">
                    <MainInput
                      label={"Name*"}
                      placeholder={"Enter Name....."}
                      required={true}
                      type={"text"}
                      value={city.nameEn}
                      onChange={(e) =>
                        handleInputChange(index, "nameEn", e.target.value)
                      }
                    />
                    <MainInput
                      label={"*اسم"}
                      placeholder={"....ادخل الاسم"}
                      required={true}
                      type={"text"}
                      dir="rtl"
                      value={city.nameAr}
                      onChange={(e) =>
                        handleInputChange(index, "nameAr", e.target.value)
                      }
                    />
                    {cities.length > 1 && (
                      <i
                        className="fa-regular fa-trash-can fs-4 mt-3 cursor-pointer"
                        onClick={() => {
                          deleteCity(index);
                        }}
                      ></i>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={loadingAddCountry}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {loadingAddCountry ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showEditCity}
        onHide={handleCloseEditCity}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="pt-3">Edit City</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={submitEditCity}
          >
            <div>
              <MainInput
                label={"Name*"}
                onChange={(e) => {
                  setCityNameEnEdit(e.target.value);
                }}
                placeholder={"Enter Name....."}
                required={true}
                type={"text"}
                value={cityNameEnEdit}
              />
              <MainInput
                label={"*اسم"}
                onChange={(e) => {
                  setCityNameArEdit(e.target.value);
                }}
                placeholder={"....ادخل الاسم"}
                required={true}
                type={"text"}
                dir="rtl"
                value={cityNameArEdit}
              />
            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={editcityLoading}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {editcityLoading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showEditCountry}
        onHide={handleCloseEditCountry}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="pt-3">Edit Country</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form
            className="d-flex flex-column justify-content-between h-100"
            onSubmit={onSubmitEditCountry}
          >
            <div>
              <MainInput
                label={"Name*"}
                onChange={(e) => {
                  setcountryNameEnEdit(e.target.value);
                }}
                placeholder={"Enter Name....."}
                required={true}
                type={"text"}
                value={countryNameEnEdit}
              />
              <MainInput
                label={"*اسم"}
                onChange={(e) => {
                  setcountryNameArEdit(e.target.value);
                }}
                placeholder={"....ادخل الاسم"}
                required={true}
                type={"text"}
                dir="rtl"
                value={countryNameArEdit}
              />
            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={countryEditLoading}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {countryEditLoading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={showAddGovernorate}
        onHide={handleCloseAddGovernorate}
        placement="end"
      >
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>Add Governorate</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <form onSubmit={handleAddNewGovernorate}>
            <div className="d-flex flex-column gap-3">
              <div>
                <MainInput
                  label={"Name*"}
                  onChange={(e) => {
                    setGovernorateEn(e.target.value);
                  }}
                  placeholder={"Enter Name....."}
                  required={true}
                  type={"text"}
                />
                <MainInput
                  label={"*اسم"}
                  onChange={(e) => {
                    setGovernorateAr(e.target.value);
                  }}
                  placeholder={"....ادخل الاسم"}
                  required={true}
                  type={"text"}
                  dir="rtl"
                />
              </div>
              <div></div>
            </div>
            <div className="d-flex justify-content-center align-items-center pb-3">
              <button
                type="submit"
                disabled={loadingAddGovernorate}
                className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold"
              >
                {loadingAddGovernorate ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Projects;
